import RevealOnScroll from '../base/RevealOnScroll';
import { serviceAreas } from '../../mocks/serviceAreas';

interface Props {
  title?: string;
  subtitle?: string;
}

export default function ServiceAreasSection({
  title = 'Serving Houston & All Surrounding Communities',
  subtitle = 'Professional property solutions delivered throughout Greater Houston TX — backed by 16+ years of local expertise.',
}: Props) {
  return (
    <section className="bg-[#F8F4EF] py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <RevealOnScroll className="mb-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-24 items-end">
            <div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-px bg-[#BF9448]" />
                <span className="text-[#BF9448] text-[10px] font-sans font-semibold tracking-[0.25em] uppercase">
                  Service Areas
                </span>
              </div>
              <h2
                className="font-serif font-semibold text-[#0F0F0F] leading-tight"
                style={{ fontSize: 'clamp(1.9rem, 3vw, 2.75rem)' }}
              >
                {title}
              </h2>
            </div>
            <div>
              <p className="font-sans text-[#7A7265] text-base leading-relaxed border-l-2 border-[#BF9448]/40 pl-6 mb-5">
                {subtitle}
              </p>
              <a
                href="tel:3463638363"
                className="inline-flex items-center gap-2 text-[#0F0F0F] hover:text-[#BF9448] font-sans text-sm font-semibold transition-colors duration-200 cursor-pointer"
              >
                <span className="w-7 h-7 flex items-center justify-center border border-[#BF9448]/40">
                  <i className="ri-phone-fill text-[#BF9448] text-xs"></i>
                </span>
                Confirm your area — 346-363-8363
              </a>
            </div>
          </div>
        </RevealOnScroll>

        {/* Areas grid */}
        <RevealOnScroll>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 mb-12">
            {serviceAreas.map((area) => (
              <div
                key={area.name}
                className={`flex flex-col items-center justify-center py-4 px-3 text-center transition-colors duration-200 cursor-default ${
                  area.primary
                    ? 'bg-[#BF9448] text-white'
                    : 'bg-white border border-[#E0D9CF] hover:border-[#BF9448]/50 text-[#4A4440]'
                }`}
              >
                {area.primary && (
                  <span className="w-4 h-4 flex items-center justify-center mb-1">
                    <i className="ri-map-pin-fill text-white/80 text-xs"></i>
                  </span>
                )}
                <span className={`font-sans text-xs font-semibold whitespace-nowrap ${area.primary ? 'text-white' : ''}`}>
                  {area.name}
                </span>
                <span className={`font-sans text-[10px] mt-0.5 ${area.primary ? 'text-white/70' : 'text-[#A09890]'}`}>
                  {area.state}
                </span>
              </div>
            ))}
          </div>
        </RevealOnScroll>

        {/* Map embed */}
        <RevealOnScroll>
          <div className="relative">
            <div className="overflow-hidden border border-[#DDD5C8]" style={{ height: '420px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d221730.7673826574!2d-95.5035803!3d29.7201865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640b8b4488d8501%3A0xca0d02def365053b!2sHouston%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="420"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="One Call Handyman Service Houston TX Service Area"
              />
            </div>
            {/* Map label overlay */}
            <div className="absolute top-4 left-4 bg-[#0F0F0F] px-4 py-3">
              <div className="font-sans text-white text-xs font-semibold tracking-wide">Greater Houston Service Area</div>
              <div className="font-sans text-white/50 text-[10px] mt-0.5">Houston TX &amp; Surrounding Cities</div>
            </div>
          </div>
        </RevealOnScroll>

      </div>
    </section>
  );
}
